import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppHeaderComponent } from './components/header/header.component';
import { AppFooterComponent } from './components/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AppInfoService } from './singletons/app-info.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [AppHeaderComponent, AppFooterComponent, RouterOutlet, HttpClientModule],
})
export class AppComponent implements OnInit {
  title = 'FSPS';

  private titleService = inject(Title);
  private appInfoService = inject(AppInfoService);

  ngOnInit() {
    this.appInfoService.getAppStartupInfo().subscribe((info) => {
      if (info?.EnvironmentName && info.EnvironmentName.toUpperCase() !== 'PROD') {
        this.titleService.setTitle(`FSPS - ${info.EnvironmentName.toUpperCase()}`);
      } else {
        this.titleService.setTitle('FSPS');
      }
    });
    // Prevent allowing users from dragging files into the window unless
    // they are dragging it onto a control that specifically allows it
    ["dragover", "drop"].forEach((eventName) => {
      window.addEventListener(eventName, (e: DragEvent) => {
        const allowDrop = document.getElementsByTagName("body")[0].classList.contains("file-drag-drop_allow-drop");

        if (allowDrop === false) {
          e && e.preventDefault();
        }
      });
    });
  }
}
